module.exports = __webpack_public_path__ + "static/media/tick.33f38075.svg";